// removed by extract-text-webpack-plugin
module.exports = {"sectionInner":"_19SE_L1Ofr100nKwLcDUEp"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/layout/Admin.css
// module id = 435
// module chunks = 0